
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vlog/recent",
      function () {
        return require("private-next-pages/vlog/recent/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vlog/recent"])
      });
    }
  